import {  IconButton, Menu, Typography, makeStyles} from "@material-ui/core"; 
import { IconMensaje, PortalContext } from "@portal/arq-portal-core";
import React, { useContext, useState } from 'react';
import {Buzones} from './Buzones'
import { Buzon } from '../types/types';
import {api} from '@portal/arq-portal-core';
const useStyles = makeStyles(() => ({
 alertasMenu:{
    '& .MuiPaper-rounded': {
        borderRadius: '0px',
        marginTop: '43px',
    },
    '& .MuiListItem-button': {
        height: '30px',
        borderBottom: '1px solid #d6d8d8',
    },
    '& .MuiList-padding': {
      paddingTop: '0px',
      paddingBottom: '0px',
      width: window.innerWidth/5
    },
    '& .MuiMenuItem-root': {
      fontSize: '12px',
    },
  },
    listItem: {
        display: 'flex',
        flexDirection: 'column', 
        paddingBottom: '3%', 
        paddingLeft: '3%',
        backgroundColor: 'white'
    }, 
    item:{
        marginTop: '2%', 
        borderBottom: '1px solid #f0f0f0'
    }
}))
function BuzonesButton(props:any){
    const {user, mostrarGestionBuzon} = useContext(PortalContext);
    const clases = useStyles(props);
    const [data, setData] = useState<Buzon[]>();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const fixedBuzon: Buzon = {Titulo: "Alta/gestión de mi buzón de correo", Url:"/Aplicacion?aplicacion=AplicacionesSCO&urlTransaccion=FE/TPG.Aplic.TSCH.FE.BuzonCorreo/" }

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null); 
    };

    const personal = [{Titulo: user?.dn ?? "", Url: user?.buzon ?? ""}];

    React.useEffect(()=>{
        var buzones:Buzon[] = personal;
        if(user?.buzones != null){
            api.get(user?.buzones).then((data: {Buzones: Buzon[]}) => {
                if (data !=null && data!= undefined) buzones = buzones.concat(data.Buzones);
                if (mostrarGestionBuzon) buzones = buzones.concat([fixedBuzon]);
                setData(buzones);
            });   
        }else{
            if (mostrarGestionBuzon) buzones = buzones.concat([fixedBuzon]);
            setData(buzones);
        }
    }, []);

    return <React.Fragment>
        <div>
            <IconButton {...props} style={{ color: "white" }} onClick={handleMenu} aria-label="Alertas">
                <IconMensaje></IconMensaje>
            </IconButton>
            <Menu 
                className={clases.alertasMenu}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {!data&&<Typography variant="body1" style={{ padding: "0px 18px", maxWidth: "300px", textAlign: "center"}}>No se han recuperado buzones</Typography>}
                {data && <Buzones datos = {data}></Buzones>}
            </Menu>
        </div>
    </React.Fragment>;
}
export default BuzonesButton;